import {useEffect, useMemo, useState} from 'react';

// Панели левого нижнего угла (чат, реакции, слои поля, редактор миссий)
// разворачиваются в одно и то же место, поэтому развернутой бывает только
// одна: разворот любой сворачивает остальные
export const CORNER_PANELS = Object.freeze({
  MISSION_EDITOR: 'missionEditor',
  CHAT: 'chat',
  REACTIONS: 'reactions',
  LAYERS: 'layers',
});

/**
 * Состояние угла для футера: какая панель развернута, колбэк
 * onExpandedChange для каждой (стабильный — панели подписывают на него
 * эффекты) и признак «свернись» для каждой
 *
 * @returns {{
 *   isAnyExpanded: boolean,
 *   getPanelProps: function(string): {onExpandedChange: function(boolean): void, isCollapseRequested: boolean},
 * }}
 */
export const useCornerPanels = () => {
  const [expandedPanel, setExpandedPanel] = useState(null);

  const handlers = useMemo(() => Object.fromEntries(
    Object.values(CORNER_PANELS).map((panel) => [
      panel,
      (isExpanded) => setExpandedPanel((prev) => {
        if (isExpanded) {
          return panel;
        }
        return prev === panel ? null : prev;
      }),
    ])
  ), []);

  return {
    isAnyExpanded: expandedPanel !== null,
    getPanelProps: (panel) => ({
      onExpandedChange: handlers[panel],
      isCollapseRequested: expandedPanel !== null && expandedPanel !== panel,
    }),
  };
};

/**
 * Для самой панели угла: свернуться, когда развернули другую
 *
 * @param {boolean} isCollapseRequested - из getPanelProps футера
 * @param {boolean} isExpanded
 * @param {function(): void} collapse
 */
export const useCollapseOnCornerPanelRequest = (isCollapseRequested, isExpanded, collapse) => {
  useEffect(() => {
    if (isCollapseRequested && isExpanded) {
      collapse();
    }
    // Только на сам запрос: collapse — новая функция на каждый рендер
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCollapseRequested]);
};
